/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_TEAM_DETAILS_REQUEST,
  FETCH_TEAM_DETAILS_SUCCESS,
  FETCH_TEAM_DETAILS_FAILURE,
} from "./TeamDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchTeamDetailsRequest = () => {
  return {
    type: FETCH_TEAM_DETAILS_REQUEST,
  };
};

export const fetchTeamDetailsSuccess = (appData) => {
  return {
    type: FETCH_TEAM_DETAILS_SUCCESS,
    payload: appData,
  };
};

export const fetchTeamDetailsFailure = (error) => {
  return {
    type: FETCH_TEAM_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchTeamDetails = (teamId) => {
  return async function (dispatch) {
    dispatch(fetchTeamDetailsRequest());
    try {
      const data = await APIManager.getTeams(teamId);
      dispatch(fetchTeamDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchTeamDetailsFailure(error));
      dispatch(commonError(error, FETCH_TEAM_DETAILS_FAILURE));
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
